import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store.js";
import vuetify from "@/plugins/vuetify";
import HighchartsVue from "highcharts-vue";
import Mapbox from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import VueGridLayout from "vue-grid-layout";
import DateRangePicker from "vue2-daterange-picker";
import draggable from "vuedraggable";
import "@mdi/font/css/materialdesignicons.css";
import { MsalPlugin } from "@/plugins/msal";
import { setConfig } from "@/config";

Vue.config.productionTip = false;

Vue.use(HighchartsVue);
Vue.use(Mapbox);
Vue.use(DateRangePicker);
Vue.use(draggable);

Vue.component("grid-layout", VueGridLayout.GridLayout);
Vue.component("grid-item", VueGridLayout.GridItem);

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { faUser, faLock, faEnvelope, faCalendar, faAnchor, faShip } from "@fortawesome/free-solid-svg-icons";
import { faGithub, faMicrosoft } from "@fortawesome/free-brands-svg-icons";

library.add(faUser, faLock, faEnvelope, faGithub, faCalendar, faAnchor, faShip, faMicrosoft);

Vue.component("font-awesome-icon", FontAwesomeIcon);

fetch("/config.json")
  .then((res) => {
    if (!res.ok) throw new Error("Failed to load config.json");
    return res.json();
  })
  .then((config) => {
    setConfig(config);
    window.APP_CONFIG = config;

    const msalOptions = {
      clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
      loginAuthority: process.env.VUE_APP_MSAL_LOGIN_AUTHORITY,
      passwordAuthority: process.env.VUE_APP_MSAL_PASSWORD_RESET_AUTHORITY,
      knownAuthority: process.env.VUE_APP_MSAL_KNOWN_AUTHORITY,
      redirectUrl: config.VUE_APP_REDIRECT_URL,
      groupId: config.VUE_APP_GROUP_ID,
    };
    Vue.use(new MsalPlugin(), msalOptions);

    new Vue({
      router,
      store,
      vuetify,
      icons: {
        iconfont: ["mdiSvg", "mdi", "mdiSvg", "md", "fa", "fa4"]
      },
      render: (h) => h(App)
    }).$mount("#app");
  })
  .catch((err) => {
    console.error(err);
    document.getElementById("app").innerText =
      "Failed to load application configuration.";
  });
